export const externalRoutes = {
  termsAndConditions: 'https://www.raps.com/company/kontakt/agb-uebersicht/',
  privacyPolicy: 'https://www.raps.com/company/kontakt/datenschutz/dsgvo',
  internship: 'https://www.raps.com/company/azubiladen/',
};
